import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import MainCard from 'components/MainCard';
import { brand } from 'utils/designTokens';

/**
 * Reusable server-side paginated & sorted DataGrid component.
 */
export default function ReportTable({
  columns,
  rows = [],
  loading = false,
  rowCount = 0,
  paginationModel,
  onPaginationModelChange,
  onSortModelChange
}) {
  return (
    <MainCard contentSX={{ p: 0 }} sx={{ border: `1px solid ${brand.border}` }}>
      <Box sx={{ height: 500, width: '100%', overflow: 'auto' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange}
          paginationMode="server"
          sortingMode="server"
          onSortModelChange={onSortModelChange}
          pageSizeOptions={[10]}
          slotProps={{
            pagination: {
              sx: {
                '& .MuiTablePagination-selectLabel': {
                  display: 'none'
                },
                '& .MuiTablePagination-input': {
                  display: 'none'
                }
              }
            }
          }}
          disableRowSelectionOnClick
          getRowId={(row) => row.id || row.order_no}
          sx={{
            border: 'none',
            '& .MuiDataGrid-columnHeader': {
              bgcolor: 'grey.50',
              color: 'text.primary',
              py: 1.5
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 700,
              fontSize: '0.72rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            },
            '& .MuiDataGrid-cell': {
              borderColor: 'divider',
              fontSize: '0.85rem'
            },
            '& .MuiDataGrid-row:hover': {
              bgcolor: 'rgba(31, 91, 64, 0.02)'
            },
            '& .MuiDataGrid-footerContainer': {
              borderColor: 'divider',
              bgcolor: 'grey.50'
            }
          }}
        />
      </Box>
    </MainCard>
  );
}

ReportTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array,
  loading: PropTypes.bool,
  rowCount: PropTypes.number,
  paginationModel: PropTypes.shape({
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired
  }),
  onPaginationModelChange: PropTypes.func,
  onSortModelChange: PropTypes.func
};
